import { queryOptions } from "@tanstack/react-query";
import { apiGet, withQuery } from "@amber/ui";
import { accessPreviewSchema } from "../../contracts/index";
import { collectionKeys } from "./keys";

export const accessPreviewQuery = (id: string, target: "deleted" | "restricted" | "normal") =>
  queryOptions({
    queryKey: collectionKeys.accessPreview(id, target),
    queryFn: ({ signal }) =>
      apiGet(
        withQuery(`/api/collection/items/${encodeURIComponent(id)}/access-preview`, { target }),
        accessPreviewSchema,
        signal,
      ),
  });
